<template>
  <div class="main-container">
    <div class="header-top">
      <div class="flex-center">
        <div class="logo-box">
          <img src="../../assets/img/logo.png" alt="">
        </div>
        <div class="search-box">
          <van-search v-model="value" placeholder="搜索" @clear="search" show-action clearable>
            <template #action>
              <div @click="search">搜索</div>
            </template>
          </van-search>
        </div>
      </div>
      <van-tabs swipeable color="#26a2ff" title-active-color="#26a2ff" :ellipsis="false" v-model="selected"
                @change="tabClick">
        <van-tab v-for="(btn, idx) in tabBtns" :key="idx" :id="btn.id" :title="btn.label"></van-tab>
      </van-tabs>
    </div>
    <div class="list-item-box">
      <div class="tab-container">
        <div class="tab-container-item">
          <div v-if="targetList.length">
            <ListItem @click.native="toDetail(item)" v-for="(item, index) in targetList" :img="item.img" :key="index"
                      :itemData="item"/>
          </div>
          <div v-if="loaded && !targetList.length" class="empty">
            —— 没有找到匹配内容 ——
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Notify,
  Dialog,
  Toast,
  Search,
  Tab,
  Tabs
} from "vant";
import tabData from '@/assets/server-data/list.json'
import ListItem from './components/listItem'

Vue.use(Notify);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Search);
Vue.use(Tab);
Vue.use(Tabs);

export default {
  name: "Index",
  components: {
    ListItem
  },
  data() {
    return {
      value: '',
      selected: '1',
      keyWords: '',
      tabBtns: tabData['tab-btns'],
      copyContent: [],
      targetList: [],
      loaded: true
    };
  },
  mounted() {
    const allGlas = []
    tabData['content'].forEach(item => {
      if (item.id === '1') {
        item.list = []
      }
    })
    tabData['content'] = JSON.parse(JSON.stringify(tabData['content']))
    tabData['content'].forEach(item => {
      if (item.id !== '1') {
        allGlas.push(...item.list)
      }
    })
    tabData['content'].forEach(item => {
      if (item.id === '1') {
        item.list = [...item.list, ...allGlas]
      }
    })
    this.copyContent = JSON.parse(JSON.stringify(tabData['content']))
    this.targetList = JSON.parse(JSON.stringify(this.copyContent[0].list))
  },
  methods: {
    tabClick(index) {
      console.log('----index---', index)
      console.log('----selected---', this.selected)
      this.targetList = []
      this.loaded = false
      Toast.loading({
        message: '加载中...',
        duration: 0, // 持续展示 toast
      });
      setTimeout(() => {
        Toast.clear()
        this.targetList = JSON.parse(JSON.stringify(this.copyContent[index].list))
        this.loaded = true
      }, 500)
    },
    search() {
      Toast.loading({
        message: '加载中...',
        duration: 0, // 持续展示 toast
      });
      console.log(this.selected)
      this.loaded = false
      setTimeout(() => {
        Toast.clear()
        this.keyWords = this.value
        this.copyContent = JSON.parse(JSON.stringify(tabData['content']))
        this.targetList = JSON.parse(JSON.stringify(this.copyContent[this.selected].list))
        const loweiKey = this.keyWords.toLowerCase()
        this.copyContent = this.copyContent.map(item => {
          item.list = item.list.filter(sItem => {
            sItem.content = sItem.content1 + sItem.content2 + sItem.content3
            const title = sItem.title.toLowerCase()
            const content = sItem.content.toLowerCase()
            const bottomText = sItem.bottomText.toLowerCase()
            return title.includes(loweiKey) || content.includes(loweiKey) || bottomText.includes(loweiKey)
          })
          console.log(item.list);
          return {
            id: item.id,
            list: item.list
          }
        })
        this.targetList = JSON.parse(JSON.stringify(this.copyContent[this.selected].list))
        this.copyContent.forEach(item => {
          item.list.length
        })
        this.loaded = true
      }, 500)
    },
    toDetail(row) {
      // 跳转查看3D详情
      this.$router.push(`/detail/${row.title}`)
    }
  }
};
</script>

<style lang="less" scoped>
.van-tab {
  padding: 0 2vw;
}

.van-search__content {
  border-radius: 24px;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .header-top {
    flex: none;
  }

  .list-item-box {
    flex: 1;
    height: 0;
    overflow: auto;
  }
}

.logo-box {
  flex: none;
  width: 24.8vw;
  padding: 0 1vw 0 2vw;

  img {
    display: block;
    width: 100%;
  }
}

.search-box {
  flex: 1;
}

.empty {
  padding: 2em;
  opacity: 0.5;
  text-align: center;
}
</style>
